import React from 'react';
export function InsuranceTicker() {
  const partners = ['AAA', 'GEICO', 'STATE FARM', 'ALLSTATE', 'PROGRESSIVE', 'USAA'];
  // Duplicate for seamless loop
  const tickerItems = [...partners, ...partners];
  return <section className="py-16 bg-white border-y border-gray-100 overflow-hidden" data-id="element-208">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8" data-id="element-209">
        <h3 className="text-center text-sm font-bold text-gray-400 tracking-[0.2em] uppercase" data-id="element-210">
          Trusted by National Partners
        </h3>
      </div>

      <div className="relative w-full flex overflow-hidden group" data-id="element-211">
        {/* Gradient Masks for smooth fade on edges */}
        <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-white to-transparent z-10" data-id="element-212"></div>
        <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-white to-transparent z-10" data-id="element-213"></div>

        {/* Scrolling Container */}
        <div className="flex animate-ticker whitespace-nowrap items-center" data-id="element-214">
          {tickerItems.map((partner, idx) => <div key={idx} className="px-12 md:px-16 text-2xl md:text-3xl font-black text-gray-300 opacity-50 hover:opacity-100 hover:text-secondary transition-all duration-300 cursor-default" data-id="element-215">
              {partner}
            </div>)}
        </div>
      </div>
    </section>;
}